import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import constants from '../../../../core/constants';
import SingleDayWeek from '../../../components/Schedule/components/SingleDayWeek';
import IDHelpers from '../../../../core/helpers/IDHelper';
import DateHelpers from '../../../../core/helpers/DateHelper';

interface Props {
  dates: any[];
  today: Date;
  selectedDate: Date;
  handleSelectDate: (date: Date) => void;
  // handleSelectMobileSlide: (date: Date) => void;
}

export interface IWeekDay {
  dayname: string;
  daynumber: string;
}

const DaysElement = styled.div`
  width: 100%;
  min-height: 54px;
  display: flex;
  padding-right: 6px;
  background-color: #f7fbfd;

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
    // margin-left: 82px;
  }
`;

function DaysOfWeek(props: Readonly<Props>) {
  const { dates, today, selectedDate, handleSelectDate } = props;
  const countDays = dates?.length;
  if (countDays === 0) return null;
  const percent = isMobile ? 100 : 100 / countDays;
  return (
    <DaysElement>
      {!isMobile && <div style={{ minWidth: 82 }} />}
      {dates ? (
        dates?.map((day: Date) => (
          <SingleDayWeek
            key={IDHelpers.generateID()}
            dayNameOfWeek={DateHelpers.getDayName2(day.getTime(), 'capitalize')}
            dayNumberOfWeek={DateHelpers.getDayWithFormat(
              day?.getTime()
            ).toString()}
            isToday={
              DateHelpers.formatFullDate(today) ===
              DateHelpers.formatFullDate(day)
            }
            isSelected={selectedDate.toString() === day.toString() && isMobile}
            percent={percent}
            onClick={() => {
              // handleSelectMobileSlide(day);
              handleSelectDate(day);
            }}
          />
        ))
      ) : (
        <div />
      )}
    </DaysElement>
  );
}

export default DaysOfWeek;
